/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import "./AllCardView.css";

import Loader from "react-loader-spinner";
import { Link } from "react-router-dom";
import {
  auth_token,
  auth_token_code,
  authority_msg,
  get_snake_details_url,
  main_web_url,
} from "../WebController/WebController";

const AllCardView = () => {
  const [snakeDetails, setSnakeDetails] = useState([]);

  useEffect(() => {
    const formData = new FormData();
    formData.append("state", "2");
    formData.append(auth_token, auth_token_code);

    fetch(get_snake_details_url, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        setSnakeDetails(data.data);
      })
      .catch((error) => {
        console.log(authority_msg);
      });
  }, []);

  return (
    <div className="container-fluid  ">
      <div className=" ">
        {snakeDetails.length > 0 ? (
          <div className="row  justify-content-center ">
            {snakeDetails.map((item) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 pb-2 mb-5 ">
                <div
                  className="main-card h-100 "
                  data-aos="fade-up"
                  data-aos-duration="3000"
                >
                  <img className=" img-fluid p-1" src={main_web_url + item.image} />
                  <div className="p-3 mb-2">
                    <h3
                      className="text-center text-success"
                      style={{ fontSize: "22px" }}
                    >
                      {item.english_name}
                    </h3>
                    <p className="text-start details_text">
                      {item.distributions}
                    </p>
                  </div>
                  <div className="read_more_div">
                    <Link
                      to={"/snake_details/" + item.id}
                      className="d-flex justify-content-end align-items-end p-1  div_footer  "
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="row justify-content-center align-items-center loader_div">
            <Loader
              type="Puff"
              color="green"
              height={100}
              width={100}
              timeout={5000} //5 secs
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AllCardView;
